import React, { useState } from "react";
import './styles.css';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Cookies from 'js-cookie';
import { encryptData } from "./cryptage";
import { FaEye, FaEyeSlash, FaEnvelope, FaLock } from "react-icons/fa";
import LogoGcDarkBg from "../imgs//LogoGcDarkBg.png";



function SignInForm() {
    const MySwal = withReactContent(Swal);
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState({
        email: "",
        password: ""
    });
    const [emailError, setEmailError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [showPassword, setShowPassword] = useState(false); 
    const navigate = useNavigate();

    const validation = (name, value) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        let isValid = true;

        if (name === "email") {
            if (!value.trim()) {
                setEmailError("Email obligatoire");
                isValid = false;
            } else if (!emailRegex.test(value)) {
                setEmailError("Email invalide");
                isValid = false;
            } else {
                setEmailError("");
            }
        }

        if (name === "password") {
            if (!value.trim()) {
                setPasswordError("Mot de passe obligatoire");
                isValid = false;
            } else {
                setPasswordError("");
            }
        }

        return isValid;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUser(prevState => ({...prevState,[name]: value}));
        validation(name, value);
    };

    const handleLogin = async (event) => {
        event.preventDefault();

        const isEmailValid = validation("email", user.email);
        const isPasswordValid = validation("password", user.password);

        if (isEmailValid && isPasswordValid) {
            setLoading(true);
            try {
                const response = await axios.post('https://ai.api.gecimmo.xyz/AI-GECIMMO/public/api/login', user, { withCredentials: true });
                
                Cookies.set('access_token', encryptData(response.data.access_token), { secure: true, sameSite: 'Strict' });
                Cookies.set('role', encryptData(response.data.role), { secure: true, sameSite: 'Strict' });
                Cookies.set('user', encryptData(JSON.stringify(response.data.user)), { secure: true, sameSite: 'Strict' });
                Cookies.set('resources', encryptData(JSON.stringify(response.data.resources)), { secure: true, sameSite: 'Strict' });
                Cookies.set('canAccessChat', "false", { secure: true, sameSite: 'Strict' });
                console.log(response.data.resources);
                if (response.data.role === "user") {
                    navigate("/home");
                }
                if (response.data.role === "admin") {
                    navigate("/dashboard");
                }
                if (response.data.role === "superAdmin") {
                    navigate("/superDashboard");
                }
                
            } catch (error) {
                setLoading(false);
                MySwal.fire({
                    title: "Error!",
                    text: "Failed to sign in. Please check your credentials.",
                    icon: "error"
                });
            }
        }
    };

    return (
        <div className="parent">
            <div className="containerdiv">
                <div className="col sign-in-container">
                    <form className="LoginForm" onSubmit={handleLogin}>
                        <h1 className="signinh1">Se connecter</h1>
                        <span className="signinspan">Utilisez votre compte</span>
                        <div className="input-container">
                            <FaEnvelope className="input-icon" />
                            <input
                                type="email"
                                placeholder="Email"
                                name="email"
                                className="formInput"
                                value={user.email}
                                onChange={handleChange}
                            />
                        </div>
                        {emailError && <div className="text-danger">{emailError}</div>}
                        <div className="input-container">
                            <FaLock className="input-icon" />
                            <input
                                type={showPassword ? "text" : "password"}
                                name="password"
                                className="formInput"
                                placeholder="Mot de passe"
                                value={user.password}
                                onChange={handleChange}
                            />
                            <span
                                className="password-toggle-icon"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>
                        </div>
                        {passwordError && <div className="text-danger">{passwordError}</div>}
                        <button className="btn-submit" type="submit" disabled={loading}>
                            <span className="button-content">
                                {loading ? "Loading..." : "Se connecter"}
                            </span>
                        </button>
                    </form>
                </div>
                <div className="col img-container">
                    <img className="image" src={LogoGcDarkBg} alt="" />
                </div>
            </div>
        </div>
    );
}

export default SignInForm;